'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DownloadModal } from '@/components/download-modal';
import { useDownloadAction } from '@/lib/use-download-action';

const navLinks: { href: string; label: string }[] = [
  { href: '#features', label: 'Fonctionnalités' },
];

export function LandingHeader() {
  const [isOpen, setIsOpen] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const { handleDownload } = useDownloadAction();

  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <Link href="/" className="flex items-center gap-3 font-semibold text-gray-900">
            <Image
              src="/finsly.svg"
              alt="Mot du jour logo"
              width={120}
              height={48}
              priority
            />
          </Link>

          <nav className="hidden items-center gap-6 text-sm font-medium text-gray-700 md:flex">
            {navLinks.map(link => (
              <a key={link.href} href={link.href} className="transition-colors hover:text-gray-900">
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <Button
              size="lg"
              variant="outline"
              className="rounded-full border-[hsl(var(--primary))] bg-[hsl(var(--primary))] text-white hover:bg-transparent hover:text-[hsl(var(--primary))]"
              onClick={() => handleDownload(() => setShowDownloadModal(true))}
            >
              Se lancer
            </Button>
          </div>

          <button
            type="button"
            onClick={() => setIsOpen(previous => !previous)}
            className="inline-flex items-center justify-center rounded-full border border-gray-200 p-2 text-gray-700 transition-colors hover:bg-gray-50 md:hidden"
            aria-label="Ouvrir le menu"
          >
            {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="border-t border-gray-200 bg-white md:hidden">
          <nav className="flex flex-col space-y-2 px-4 py-4 text-sm font-medium text-gray-700">
            {navLinks.map(link => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-lg px-4 py-2 transition-colors hover:bg-gray-50"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <Button
              className="rounded-full border-[hsl(var(--primary))] bg-[hsl(var(--primary))] text-white hover:bg-transparent hover:text-[hsl(var(--primary))]"
              onClick={() => {
                setIsOpen(false);
                handleDownload(() => setShowDownloadModal(true));
              }}
            >
              Essayez gratuitement
            </Button>
          </nav>
        </div>
      )}

      <DownloadModal open={showDownloadModal} onOpenChange={setShowDownloadModal} />
    </header>
  );
}

